import {createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'FP_SURVEY';
export const {action: fetchAll, failed: fetchAllFailed} = createAction(`${domain}/FETCH_ALL`, () => ({}));

export const {action: fetchAllSuccess} = createAction(`${domain}/FETCH_ALL_DONE`, billPayerIds => ({billPayerIds}));
